import { useState, useEffect } from "react";

export const useComponentDidMount = () => {
	const [ didMount, setDidMount ] = useState(false);

	useEffect(() => setDidMount(true), []);

	return didMount;
};

export default useComponentDidMount;